import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNoQualifyFallback = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety nie możemy zaoferować obsługi Twojej sprawy'
      )}
      withButton
    >
      <>
        <span>
          {i18n.t('Przepraszamy za wszelkie niedogodności i ograniczenia.')}
        </span>
        <span>
          {i18n.t(
            'Jeśli masz jakiekolwiek pytania lub wątpliwości, jesteśmy otwarci na pomoc i służymy doradztwem w zakresie dostępnych opcji oraz procedur.'
          )}
        </span>
        <span className="font-semibold">
          {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
        </span>
      </>
    </AfterDoc>
  );
};

export default ThankYouNoQualifyFallback;
